"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var bootstrap_vue_1 = require("bootstrap-vue");
var date_1 = require("../../util/date");
var DefaultInput = /** @class */ (function () {
    function DefaultInput(label, options) {
        if (options === void 0) { options = {}; }
        this.label = label;
        this.options = options;
    }
    Object.defineProperty(DefaultInput.prototype, "component", {
        get: function () {
            return bootstrap_vue_1.BFormInput;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultInput.prototype, "props", {
        get: function () {
            return this.options.props || {};
        },
        enumerable: true,
        configurable: true
    });
    DefaultInput.prototype.extendComponentProps = function (obj) {
        return Object.assign({}, this.options.props || {}, obj);
    };
    DefaultInput.prototype.toString = function () {
        return this.label;
    };
    return DefaultInput;
}());
exports.DefaultInput = DefaultInput;
var ReadOnlyInput = /** @class */ (function (_super) {
    tslib_1.__extends(ReadOnlyInput, _super);
    function ReadOnlyInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ReadOnlyInput.prototype, "props", {
        get: function () {
            return this.extendComponentProps({
                readonly: true,
            });
        },
        enumerable: true,
        configurable: true
    });
    return ReadOnlyInput;
}(DefaultInput));
exports.ReadOnlyInput = ReadOnlyInput;
var DateInput = /** @class */ (function (_super) {
    tslib_1.__extends(DateInput, _super);
    function DateInput(label, options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, label, options) || this;
        _this.format = options.format || 'MM/dd/yyyy';
        return _this;
    }
    Object.defineProperty(DateInput.prototype, "props", {
        get: function () {
            var _this = this;
            return this.extendComponentProps({
                lazyFormatter: true,
                formatter: function (value) {
                    var date = new Date(value + " 00:00:00");
                    return date_1.normalizeUserDateInput(date, _this.format);
                },
            });
        },
        enumerable: true,
        configurable: true
    });
    return DateInput;
}(DefaultInput));
exports.DateInput = DateInput;
var CurrencyInput = /** @class */ (function (_super) {
    tslib_1.__extends(CurrencyInput, _super);
    function CurrencyInput(label, options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, label, options) || this;
        _this.currencyCode = options.currencyCode || 'USD';
        return _this;
    }
    Object.defineProperty(CurrencyInput.prototype, "props", {
        get: function () {
            return this.extendComponentProps({
                class: ['text-right'],
                lazyFormatter: true,
                formatter: function (value) {
                    return Number(value).toFixed(2);
                },
            });
        },
        enumerable: true,
        configurable: true
    });
    return CurrencyInput;
}(DefaultInput));
exports.CurrencyInput = CurrencyInput;
var EnumeratedInput = /** @class */ (function (_super) {
    tslib_1.__extends(EnumeratedInput, _super);
    function EnumeratedInput(label, choices, options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, label, options) || this;
        _this.choices = choices;
        return _this;
    }
    Object.defineProperty(EnumeratedInput.prototype, "component", {
        get: function () {
            return bootstrap_vue_1.BFormSelect;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EnumeratedInput.prototype, "props", {
        get: function () {
            return this.extendComponentProps({
                options: this.choices
            });
        },
        enumerable: true,
        configurable: true
    });
    return EnumeratedInput;
}(DefaultInput));
exports.EnumeratedInput = EnumeratedInput;
var EnumeratedInputOption = /** @class */ (function () {
    function EnumeratedInputOption(value, text, disabled) {
        this.value = value;
        this.text = text || value;
        this.disabled = disabled || false;
    }
    return EnumeratedInputOption;
}());
exports.EnumeratedInputOption = EnumeratedInputOption;
var EnumeratedInputOptionGroup = /** @class */ (function () {
    function EnumeratedInputOptionGroup(label, choices) {
        this.options = choices;
        this.label = label;
    }
    return EnumeratedInputOptionGroup;
}());
exports.EnumeratedInputOptionGroup = EnumeratedInputOptionGroup;
var DefaultCheckbox = /** @class */ (function (_super) {
    tslib_1.__extends(DefaultCheckbox, _super);
    function DefaultCheckbox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(DefaultCheckbox.prototype, "component", {
        get: function () {
            return bootstrap_vue_1.BFormCheckbox;
        },
        enumerable: true,
        configurable: true
    });
    return DefaultCheckbox;
}(DefaultInput));
exports.DefaultCheckbox = DefaultCheckbox;
var DefaultTextArea = /** @class */ (function (_super) {
    tslib_1.__extends(DefaultTextArea, _super);
    function DefaultTextArea() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(DefaultTextArea.prototype, "component", {
        get: function () {
            return bootstrap_vue_1.BFormTextarea;
        },
        enumerable: true,
        configurable: true
    });
    return DefaultTextArea;
}(DefaultInput));
exports.DefaultTextArea = DefaultTextArea;
var PrimaryKeyInput = /** @class */ (function (_super) {
    tslib_1.__extends(PrimaryKeyInput, _super);
    function PrimaryKeyInput(label, relatedDisplayKey, options) {
        if (options === void 0) { options = {}; }
        var _this = this;
        if (!options.props) {
            options.props = {};
        }
        if ('function' === typeof options.format) {
            options.props.format = options.format;
        }
        _this = _super.call(this, label, options) || this;
        _this.relatedDisplayKey = relatedDisplayKey;
        return _this;
    }
    Object.defineProperty(PrimaryKeyInput.prototype, "component", {
        get: function () {
            // Compiler doesn't like this as an import statement at the top @todo fix
            return require('../InputSelectRelatedResource').default;
        },
        enumerable: true,
        configurable: true
    });
    return PrimaryKeyInput;
}(DefaultInput));
exports.PrimaryKeyInput = PrimaryKeyInput;
exports.inputs = {
    DefaultInput: DefaultInput,
    ReadOnlyInput: ReadOnlyInput,
    DateInput: DateInput,
    CurrencyInput: CurrencyInput,
    EnumeratedInput: EnumeratedInput,
    EnumeratedInputOption: EnumeratedInputOption,
    EnumeratedInputOptionGroup: EnumeratedInputOptionGroup,
    DefaultCheckbox: DefaultCheckbox,
    DefaultTextArea: DefaultTextArea,
    PrimaryKeyInput: PrimaryKeyInput
};
//# sourceMappingURL=inputs.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/components/formsets/inputs.js
// module id = IRal
// module chunks = 0